import { Component, EventEmitter,  Inject, Input, Output, OnInit, AfterViewInit} from 'ng-metadata/core';
import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {SmoothScrollUtil} from "../../../nddUtils/smoothScrollUtil.service";
import {CollectionDiscoveryService} from "../../../collectionDiscovery/collectionDiscovery.service";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {ChangeLangService} from "../../../infra/lang/changeLang.service";
import {DirectLinkService} from "../../directLink/directLink.service";
import {TemplateUtil} from "../../../nddUtils/templateUtil.service";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";
import {PreFiltersService} from "../../preFilters/preFilters.service";
import {getEnableDirectLinkingInFullView} from "../../../appConfig/appConfigForward";
import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";

import {
    isNgrs,
    getPrimoVeDeliveryBulkFromBrief,
    getPrimoVeBriefResultsJournalCoverage,
    getVid
} from '../../../appConfig/appConfigForward';
import {HighlightService} from "../../../infra/highlight.service";
import { SearchService } from '../../search.service';

let he= require('he');
const get= require('lodash/get');
const find = require('lodash/find');
const cloneDeep = require('lodash/cloneDeep');

const emptyArray = [];

@Component({
    "selector": "prm-search-result-availability-line",
    templateUrl: 'components/search/searchResult/searchResultAvailability/searchResultAvailabilityLine.html'
})

export class PrmSearchResultAvailabilityLine implements OnInit{

    private broadenAvailabilities : string[] = [
        'Acquisition', 'ClaimedReturned', 'HoldShelf', 'Loan', 
        'Lost', 'InProcess', 'Missing', 'NotinProcess', 
        'ResourceSharingRequest', 'TechnicalMigration', 'Transit', 'Requested'
    ];

    private availabilityLineIcons: Object[];
    private _organization:string;
    private _libraryCode:string;
    private _subLocation:string;
    private _callNumber:string;
    private locationReady:boolean;
    private showTimer = false;
    private isCollectionDiscoveryCollection: boolean;
    private locationsPrefilter: Array<string>;
    private COLLECTION_DISCOVERY_STATE = STATE_NAMES.COLLECTION_DISCOVERY;
    private _collectionStateParams: Object;
    private isBidi= {};

    private isReversed:boolean = false;
    private unfilterLocationPressed:boolean = false;

    @Input() private isOverlayFullView:boolean;
    @Input() private result: any;
    @Input() private isFullView: boolean;
    @Input() private collectionDiscoveryData: { type; collectionId; institution };
    @Input() private isRefEntry: any;
    @Input() public displayMode: string;
    @Output() openFullDisplayWithGetit1 = new EventEmitter<Object>();
    @Output() openFullDisplayWithNgrs = new EventEmitter<Object>();

    constructor(@Inject('availabilityLineIcons') availabilityLineIcons,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private primolyticsService: PrimolyticsService,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService,
                private configurationUtil: ConfigurationUtil,
                private collectionDiscoveryService: CollectionDiscoveryService,
                private highlightService:HighlightService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private changeLangService: ChangeLangService,
                private directLinkService: DirectLinkService,
                private templateUtil: TemplateUtil,
                private searchService : SearchService,
                private mappingTablesCache : MappingTablesCache,
                private preFiltersService: PreFiltersService,
                @Inject('$scope') private $scope: ng.IScope,
                private analyticsUtils: AnalyticsUtils) {
        this.availabilityLineIcons = availabilityLineIcons;
        this.locationReady = false;
        if(this.configurationUtil.isSuprima()){
            this.$timeout(()=>{
                this.showTimer= true;
            },2000);
        }else{
            this.showTimer= true;
        }

        this.$scope.$on('unfilterLocationsPressedEvent', (event, recordId)=> {
            this.handleUnfilterLocationsPressedEvent(recordId);
        });
    }


    ngOnInit() {
        if (this.collectionDiscoveryData){
            this.isCollectionDiscoveryCollection=  this.collectionDiscoveryData.type === 'COLLECTION' || this.collectionDiscoveryData.type === 'TOPCOLLECTION';
            this._collectionStateParams= {collectionId: this.collectionDiscoveryData.collectionId, inst: this.collectionDiscoveryData.institution,
                vid: this.$stateParams['vid'], lang: this.$stateParams['lang']};
        }

        let availabilityArray = get(this.result , 'delivery.availability') || emptyArray;
    }

    ngAfterViewInit() {
        this.$timeout(() => {
            this.removeRollButton();
        }, 0);
    }

    private scrollToElementId(scrollId){
        // let eID = "getit_link1_0";
        let eID= scrollId;
        let elm = document.getElementById(eID);
        if(!elm){
            eID = "links";
            elm = document.getElementById(eID);
        }
        elm.classList.add("section-focused");

        this.$timeout(()=>{
            elm.classList.remove("section-focused");
        }, 500);
        if (this.isOverlayFullView){
            this.smoothScrollUtil.scrollTo(eID,'','sticky-scroll');
        }
        else{
            this.smoothScrollUtil.scrollTo(eID,'','');
        }
    }

    public isEmailMode() {
        return this.displayMode === 'email';
    }

    public initLocation(){
        if(this.result.delivery.bestlocation!= undefined){
            this.result.delivery.bestlocation.pendingRender = false;
            this.locationReady = true;
            this.initOrg();
            this.initLibraryCode();
            this.initSubLocation()
        }
    }

    public availabilityLinks(){
        if (this.result && this.result.delivery && this.result.delivery.availabilityLinks) {
            return this.result.delivery.availabilityLinks;
        }
        return emptyArray;
    }

    public availabilityLinksUrl(){
        if (this.result && this.result.delivery && this.result.delivery.availabilityLinksUrl) {
            return this.result.delivery.availabilityLinksUrl;
        }
        return emptyArray;
    }

    public delCategories(){
        return get(this.result, 'delivery.deliveryCategory') || emptyArray;
    }

    public isbriefResultsJournalCoverageEnabledInPrimo() {
        return this.searchService.isbriefResultsJournalCoverageEnabledInPrimo();
    }

    public isbriefResultsJournalCoverageEnabledInPrimoVE() {
        return getPrimoVeDeliveryBulkFromBrief() && getPrimoVeBriefResultsJournalCoverage();
    }

    get displayedAvailability() {
        // PRM-41913 - phisycal item should come before online resourse in availabilty, currently the delivery manager is sending
        // the online resource first and we need to reverse it. this behaviour must preserve for all records (brief, full, deeplink, favorites).
        // please try to keep all the reverse actions in one place!
        if (this.result && this.result.delivery) {
            if(!this.result.delivery.origAvailability && this.result.delivery.availability && 
                this.result.delivery.availability.length > 1){
                if(this.isPhysical(1,this.result.delivery.availability[1])){
                    this.result.delivery.availability.reverse();
                    this.result.delivery.origAvailability = this.result.delivery.availability.slice();
                    if (this.result.delivery.availabilityLinks) this.result.delivery.availabilityLinks.reverse();
                    if (this.result.delivery.availabilityLinksUrl) this.result.delivery.availabilityLinksUrl.reverse();
                    if (this.result.delivery.deliveryCategory) this.result.delivery.deliveryCategory.reverse();
                    if (this.result.delivery.serviceMode) this.result.delivery.serviceMode.reverse();
                }
               else{
                this.result.delivery.origAvailability = this.result.delivery.availability.slice();
               }
            }
            if (!this.configurationUtil.isSuprima() && (get(this.result, 'delivery.origAvailability[0]') !== get(this.result, 'delivery.availability[0]'))){
                this.result.delivery.availability.reverse();
                this.result.delivery.origAvailability = this.result.delivery.availability.slice();
            }
        }
        
        let avail = get(this.result, 'delivery.availability');
        let viewToLibraryRtaFeatureFlag = this.configurationUtil.getFeatureFlag('view_to_library_for_rta');
        if(this.configurationUtil.isSuprima() && viewToLibraryRtaFeatureFlag && !this.unfilterLocationPressed){
            avail = this.preFiltersService.updateByLocationPreFilter(avail, this.result);
        }
        avail = avail.includes('collection')?['collection']:avail;
        return avail || emptyArray;
			}
			
    private handleUnfilterLocationsPressedEvent(recordId){
        if(recordId === this.result.pnx.control.recordid){
            this.unfilterLocationPressed = true;
            if(this.result.delivery.filteredAvailability){
                this.result.delivery.availability = this.result.delivery.filteredAvailability;
            }
            if(this.result.delivery.filteredBestLocation){
                this.result.delivery.bestlocation = this.result.delivery.filteredBestLocation;
            }
            this.initLocation();
        }
    }

    private broadenAvailabilityStatusClass(availability : string){
        if(this.broadenAvailabilities.indexOf(availability) > -1){
            return 'unavailable';
        }
        return '';
    }
    
    private ifShowAvailability(availability){
        let serviceMode = get(this.result,'delivery.serviceMode',[]);
        let auxiliaryMode = get(this.result, 'delivery.digitalAuxiliaryMode', false);
        // If the availability is "no_inventory" and the record is electronic with resource sharing don't show it.
        if(!auxiliaryMode && (availability === "no_inventory" && serviceMode && serviceMode.indexOf("howovp") > -1 && serviceMode.indexOf("Viewit") > -1)){
                return false;
        }
        return true;
    }

    set libraryCode(value: string) {
        this._libraryCode = value;
    }
    set subLocation(value: string) {
        this._subLocation = value;
    }
    set organization(value: string) {
        this._organization = value;
    }
    set callNumber(value: string) {
        this._callNumber = value;
    }



    private getTranslatedLine(status){

        let bestLocation = this.result.delivery.bestlocation || {};
        let callNumberJson= {};
        let callNumber = bestLocation.callNumber || '';
        let organization = bestLocation.organization || '';
        let libraryCode = bestLocation.libraryCode || '';
        let subLocation = bestLocation.subLocation || '';


        let placeHolders = {
            idx_0: this.$translate.instant(organization),
            idx_1: this.$translate.instant(libraryCode),
            idx_2: this.$translate.instant(subLocation),
            idx_3: bestLocation.callNumber,
            idx_4: this.$translate.instant(this.result.delivery.formatedDueDate || '')
        };

        if(this.result.delivery.formatedDueDate){
            status=status+".tooltip.duedate";
        }
        let label = this.$translate.instant(status, placeHolders);
        label= he.decode(label);
        return label;

    }

    getTitle() {
        let recTitle = get(this.result, 'pnx.display.title');
        return recTitle[0];
    }

    public getAvailabilityAriaLabelledBy(index: number): string {
        const recordId = this.result.pnx.control.recordid.toString();

        let labelledBy =
            recordId + 'titleForAccessibilityAvailabilityLine' + index +
            ' ' +
            recordId + 'availabilityLine' + index;

        if (this.isDirectLink(index)) {
            labelledBy += ' ' + recordId + 'newWindowNote' + index;
        }

        return labelledBy;
    }

    getPlaceHolders() {
        if(!this.locationReady || get(this.result, 'delivery.bestlocation.pendingRender')) {
            this.initLocation()
        }
        let callNumber = this.callNumber  || "";
        let organization = this.organization || "";
        let libraryCode = this.libraryCode  || "";
        let subLocation = this.subLocation  || "";
        let libraryHtml = `<span class="best-location-library-code locations-link">${libraryCode}</span>`;
        let sublocationHtml = `<span class="best-location-sub-location locations-link">${subLocation}</span>`;
        let callnumberHtml = `<span class="best-location-delivery locations-link" dir="auto">${callNumber}</span>`;

        let placeHolders = {
            idx_0: `<span class="best-location-organization locations-link">${organization}</span>`,
            idx_1: `${libraryHtml} ${sublocationHtml} ${callnumberHtml}`,
            idx_2: `<span class="best-location-due-date">${this.result.delivery.formatedDueDate}</span>`,
        };

        return placeHolders;

    }

    public initOrg(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let org = bestLocation.organization || '';
        this.$translate(org,[],'', org).then(translation=> {this.organization = translation});
    }

    get organization(){
        return this._organization;
    }

    public initLibraryCode(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let lib =  bestLocation.libraryCode || '';
        let instCode = bestLocation.organization;
        if(!this.configurationUtil.isSuprima() && lib){
            this.$translate(instCode+'.library.'+lib,[],'', this.$translate.instant(lib)).then(translation=> {this.libraryCode = translation});
        }else{
			if (lib) {
            	this.$translate(lib,[],'', lib).then(translation=> {this.libraryCode = translation});
			}
        }


    }


    get libraryCode(){
        return this._libraryCode;
    }


    public initSubLocation(){
        let bestLocation = this.result.delivery.bestlocation || {};
        let subLoc =  bestLocation.subLocation || '';
        let instCode = bestLocation.organization;
        if(!this.configurationUtil.isSuprima() && subLoc){
            this.subLocation = subLoc;
            /* if value contains any dot (.), it means that no needed to translate it */
            this.$translate(subLoc,[],'',subLoc).then(defaultTranslation=>{
                    this.$translate(instCode+'.collection.'+subLoc,[],'', defaultTranslation).then(translation=> {this.subLocation = translation})
                });
        }else{
            // The sub location already comes translated from the server, no need to translate it again
            this.subLocation = subLoc;
        }

    }

    get subLocation(){
        return this._subLocation
    }

    get callNumber(){
        let bestLocation = this.result.delivery.bestlocation || {};

        let res = this.highlightService.bidirectionalText(bestLocation.callNumber);
        let callNumber = res.fixedStr || '';
        this.isBidi['callNumber'] = res.isBidi;
        if (callNumber.length > 0 && this.configurationUtil.isSuprima()) {
            return `<span class="availability-line-parenthesis">(</span>` + callNumber + `<span class="availability-line-parenthesis">)</span>`;
        }
        return callNumber;
    }

    showPhysicalItemTextCodes() {
        return this.result.delivery.physicalItemTextCodes;
    }

    showDisplayOtherLocations() {
        let hasAvailableOtherLocation = true;
        if(this.configurationUtil.isSuprima()) {
            let availability = get(this.result, 'delivery.availability', []);
            hasAvailableOtherLocation = find(availability, (avail) => avail != 'unavailable')
        }

        return this.result.delivery.feDisplayOtherLocations && hasAvailableOtherLocation;
    }

    showDisplayLocation() {
         return !this.configurationUtil.isSuprima() && this.result.delivery.displayLocation;
    }

    handleAvailability(index, $event) {
        //console.log(this.isFullView);
        //if (true) {
        this.handleAvailabilityLine(index, $event);
        //}
    }

    handleDueDate(status){
        if(this.result.delivery.formatedDueDate){
            status=status+".duedate";
        }
        return this.handleNgrs(status);
    }

    handleNgrs(status){
        
        if(this.isGlobalRapidoRecord(status)) {
        	return "ngrs.get_it_for_me";
        }
        
        if(this.isUnavailableRapidoRecord(status)){
        	return "ngrs." + status;
        }
        
        return status;
    }
    
    isUnavailableRapidoRecord(status){
        
        if(this.isNgrs()){
            if(status === 'unavailable' || status === 'not_available'){
                return true;
            }
        }
        return false;
    }
    
    isGlobalRapidoRecord(status) {
    	
    	//non Rapido
    	if(!this.isNgrs()){
    		return false;
    	}
    	
    	//check for local mms
    	let localAlmaIndicator = get(this.result,'pnx.control.recordid');
    	if(localAlmaIndicator && localAlmaIndicator[0].match(/^alma.*/) ) {
    		return false;
    	}
    	
    	//check for Rapido local mapping
    	let rapidoLocalIndicator = get(this.result,'pnx.control.rapidosourcerecordid');
		if(rapidoLocalIndicator) {
			return false;
		}
		
		//only return Rapido service if record is not available online.
		if(status && ( status.indexOf('no_fulltext') === 0 || status.indexOf('no_inventory') === 0 )) {
			return true;
		}

    	return false;
    }

     isEsploroRecord() {
        if (this.result &&
            this.result.pnx &&
            this.result.pnx.control &&
            this.result.pnx.control.sourceformat &&
            this.result.pnx.control.sourceformat.length > 0 &&
            this.result.pnx.control.sourceformat[0] === 'ESPLORO') {
            return true;
        }

        return false;
    }
    
    showOtherLibraries(status){
        
        if(this.isUnavailableRapidoRecord(status) || this.isGlobalRapidoRecord(status)){
           return true;
        }
        return false;
    }

    showOtherLibrariesNotOwned(status){
        return this.isGlobalRapidoRecord(status);
    }

    showSelfOwnedOtherLibraries(status){
        return this.isUnavailableRapidoRecord(status);
    }
    
    
    showCoverage(availability){
        return availability == 'not_restricted' && ( this.configurationUtil.isSuprima() ? this.isbriefResultsJournalCoverageEnabledInPrimoVE() : this.isbriefResultsJournalCoverageEnabledInPrimo() );
    }
    
    getCoverage() {
    	return get(this.result , 'delivery.consolidatedCoverage');
    }

    @beacon({'p':'brief', 'op':'availabilityStatement','item':'result'})
    private runBeaconForAvailabilityStatement() {}

    @beacon({'p': 'linksService', 'op': 'ReferenceEntry-Full-text'})
    private runBeaconForReferenceEntry() {}

    handleAvailabilityLine(index, $event) {
        this.isRefEntry? this.runBeaconForReferenceEntry() : this.runBeaconForAvailabilityStatement();this.sendAnalytics(index);
        if (this.isEsploroRecord()){
            this.triggerFullViewOpenGetIt1(index);
            return;
        }

        if(this.doPrimoVEDirectLink(index) && !this.isRefEntry){
            this.getAndOpenPrimoVEDirectLink();
        }
        else if (this.isDirectLink(index)) {
            let avalinkUrl =  this.availabilityLinksUrl()[index];
            window.open(avalinkUrl,'_blank');
        }
        else if(this.isNgrs()){
            //throw event that will trigger full view with focus on 'get it from other location' tab

            this.triggerFullViewOpenNgrs(index);
        }
        else {
            //throw event that will trigger full view with focus on 'getit1' tab
            this.triggerFullViewOpenGetIt1(index);
        }
        //for beacon only - new field in this.result
        this.result.beaconIsPhsical = this.isPhysical(index);
    }

    public sendCollectionDiscoveryBeacon(){
        this.runCollectionDiscoveryBeacon(this.result)
    }
   
    @beacon({ 'p': 'brief', 'op': 'linktoCollection'})
    public runCollectionDiscoveryBeacon(result?) {}

    private doPrimoVEDirectLink(index) {
        return this.configurationUtil.isSuprima() &&
            this.mappingTablesCache.findByProperties('direct linking config', {target: 'enableDirectLinking'})[0].source1 === 'YES' &&
            !this.isDigitalAndDirectLinkingDisabledForDigital(index) &&
            !this.isJournalAndDirectLinkingDisabledForJournal(index) &&
            ( !(this.isFullView || this.isOverlayFullView) || getEnableDirectLinkingInFullView()) &&
            this.isOnline(index, this.displayedAvailability[index]) &&
            this.isAvailable(this.displayedAvailability[index]);
    }

    private isAvailable(availability) {
        return !(availability.indexOf("unavailable") !== -1 || 
        availability.indexOf("no_") !== -1 || 
        availability === "restricted" || 
        availability === "duedate");
    }

    private getAndOpenPrimoVEDirectLink() {
        let popupWin = window.open('', '_blank');
        this.directLinkService.getDirectLinkURL(this.result, this.isFullView , this.isOverlayFullView ).then((fullTextURL: string) => {
            if (fullTextURL) {
                popupWin.location = fullTextURL;
            }
            else {
                popupWin.location = this.templateUtil.getDeepLinkAbsPath(this.result);
            }
        }, (err) => {
            popupWin.location = this.templateUtil.getDeepLinkAbsPath(this.result);
        });
    }

    private triggerFullViewOpenGetIt1(index){
        //throw event that will trigger full view with focus on 'getit1' tab
        let getitIndex = 0;
        if (this.result.delivery.availability.length === 2 && !this.isElectronicWithHTGI()) {
            getitIndex = 1 - index;
        }
        if(this.isFull()){
            return this.scrollToElementId('getit_link1_'+getitIndex);
        }
        let eventData = {index:'getit_link1_'+getitIndex, target: this.$element[0]};
        if (getSelection().toString().length > 0) {
            if (getSelection().empty) {
                getSelection().empty();
            } else if (getSelection().removeAllRanges) {
                getSelection().removeAllRanges();
            }
        }
        this.openFullDisplayWithGetit1.emit(eventData);
    }

    private triggerFullViewOpenNgrs(index){
        //throw event that will trigger full view with focus on 'rapidoOffer' tab
        if ((this.result.delivery.availability[index] === 'not_available' || this.result.delivery.availability[index] === 'unavailable' || this.result.delivery.availability[index] === 'no_inventory')){
            if(this.isFull()){
                return this.scrollToElementId('rapidoOffer');
            }
            let eventData = {index:'rapidoOffer', target: this.$element[0]};
            this.openFullDisplayWithNgrs.emit(eventData);
        }
        else{
            this.triggerFullViewOpenGetIt1(index);
        }
    }



    isDirectLink(index) {
        if (index === undefined) {
            return false;
        }
        if (this.isEsploroRecord()){
            return false;
        }
        if(this.configurationUtil.isSuprima() && this.doPrimoVEDirectLink(index)){
            return true;
        }
        else if ((this.availabilityLinks().length > 0) && (this.availabilityLinks()[index] === 'directlink')) {
            if(this.configurationUtil.isSuprima() && !this.isRefEntry){
                return false;
            }
            return true;
        }
        return false;

    }

    isElectronicWithHTGI(){
        // If 'discovery_display_resource_sharing_when_electronic_available' setting is enabled howovp section appears
        // on electronic records, so if there are both 'Viewit' and 'howovp' sections the record is not Physical.
        let serviceMode = get(this.result,'delivery.serviceMode',[]);
        let electronicWithHTGI = serviceMode && serviceMode.indexOf("howovp") > -1 && serviceMode.indexOf("Viewit") > -1;  
        return electronicWithHTGI ;

    }


    isPhysical(index,availability) {
        
        let electronicWithHTGI =  this.isElectronicWithHTGI();
        let delCategories = this.delCategories();
        if (!electronicWithHTGI && ((delCategories[index] === 'Physical Item') || (delCategories[index] === 'Microform') ||
            (delCategories[index] === 'Alma-P') ||
            (delCategories[index] === 'Remote Search Resource' && availability === 'worldcat'))) {
            return true;
        }
        return false;
    }

    isOnline(index,availability) {
        // console.log(availability +"   " + this.delCategories[index]);
        if (!this.isPhysical(index) && (!(this.delCategories()[index] === 'Remote Search Resource' && availability === 'worldcat'))) {
            return true;
        }
        return false;
    }

    isDigital(index) {
        return this.delCategories()[index] === 'Alma-D';
    }

    isDigitalAndDirectLinkingDisabledForDigital(index) {
        return this.isDigital(index) &&
            (this.mappingTablesCache.findByProperties('direct linking config', {target: 'disableDirectLinkingForDigital'})[0].source1 === 'true');
    }

    isJournalAndDirectLinkingDisabledForJournal(index) {
        let type = get(this.result, 'pnx.display.type[0]');
        return type === 'journal' &&
            (this.mappingTablesCache.findByProperties('direct linking config', {target: 'disableDirectLinkingForJournals'})[0].source1 === 'true');
    }

    isNgrs(){
        return isNgrs();
    }


    isFull() {
        if (!this.isFullView || this.isFullView === undefined) {
            return false;
        }
        return true;
    }

    get collectionStateParams(){
        return this._collectionStateParams;
    }

    private showDedupOtherLocations () {

        if (get(this.result,'pnx.dedup') != undefined) {
            if (get(this.result,'pnx.display.availlibrary.length', 0) > 1) {
                return true;
            }
        }
        return false;
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    getNgrsStyle(){
        let ngrsStyle = {};
        if(this.isNgrs()){
            ngrsStyle = { 'color': 'green'};
        }
        return ngrsStyle;
    }

    private removeRollButton() {
        let elem = this.$element[0];
        if (elem) {
            elem.removeAttribute('role');
        }
    }

    private sendAnalytics(index) {
        if (!this.isDirectLink(index)){
            let payload = this.getAnalyticsPayload(index,this.analyticsUtils.eventsNames.DISPLAY_FULL_RECORD);
            this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.DISPLAY_FULL_RECORD, payload);
        } else { //direct link
            let payload = this.getAnalyticsPayload(index, this.analyticsUtils.eventsNames.ONLINE_RESOURCE_LINK);
            this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.ONLINE_RESOURCE_LINK, payload);
        } 
    }

    private getAnalyticsPayload(index, eventName) {
        let payload = {};
        switch (eventName) {
            case this.analyticsUtils.eventsNames.DISPLAY_FULL_RECORD:
                payload = {
                    "Clicked On": this.isPhysical(index) ? 'Physical Availability' : 'Online Availability',
                    "Resource Type": this.recordType,
                    "Record Title": this.recordTitle,
                    "Record ID": this.recordid              
                }
                break;

                case this.analyticsUtils.eventsNames.ONLINE_RESOURCE_LINK:
                    payload = {
                        "Online Resource Link Type": this.isDigital(index) ? 'Link to Resource - Digital ' : 'Link to Resource - Electronic',
                        "Displayed Link Name": "Available Online",
                        "Record Title": this.recordTitle,
                        "Record ID": this.recordid,
                        "Resource Type": this.recordType
                    }
                    break;
                
            default:
                break;
        }

        return payload;
    }

    get recordid(){
        return get(this.result, 'pnx.control.recordid[0]');
    }

    get recordTitle(){
        return get(this.result, 'pnx.display.title[0]');
    }

    get recordType(){
        return get(this.result, 'pnx.display.type[0]');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultAvailability/searchResultAvailabilityLine.directive.ts